export interface FaqItem {
  question: string;
  answer: string;
}

export const CALCULATOR_FAQS: Record<string, FaqItem[]> = {
  "sentencia-administrativa": [
    {
      question: "¿Qué liquida la calculadora de sentencias administrativas?",
      answer: "Liquida condenas contra el Estado: actualiza el capital con el IPC (indexación) y suma los intereses correspondientes —DTF y mora comercial— conforme al Art. 192 de la Ley 1437 de 2011 (CPACA)."
    },
    {
      question: "¿Qué es el plazo de gracia del Art. 192 del CPACA?",
      answer: "El Art. 192 del CPACA otorga 10 meses de plazo de gracia contados desde la ejecutoria de la sentencia. Durante ese término la entidad puede pagar sin incurrir en mora; vencido, empiezan a correr los intereses moratorios."
    },
    {
      question: "¿Cómo se calculan los intereses sobre la condena?",
      answer: "Se calculan en interés simple, pues el anatocismo está proscrito. La calculadora convierte la tasa efectiva anual a tasa nominal diaria (id = (1+TEA)^(1/365) - 1) y distingue una fase con DTF y otra con mora comercial."
    },
    {
      question: "¿Las costas y agencias en derecho se indexan?",
      answer: "No. Según jurisprudencia del Consejo de Estado las costas y agencias en derecho no se indexan; por eso se ingresan aparte del capital que sí se actualiza con el IPC."
    }
  ],
  "privacion-injusta": [
    {
      question: "¿Cómo se determina el monto del daño moral en privación injusta?",
      answer: "Se aplica la Sentencia de Unificación de la Sección Tercera del Consejo de Estado (Rad. 36009) que establece escalas fijas en SMLMV según el número de meses de detención efectiva (15 a 100 SMLMV)."
    },
    {
      question: "¿Qué indemnización le corresponde a los familiares?",
      answer: "El cónyuge, hijos y padres de la víctima directa tienen derecho al 80% o 100% de la indemnización por daño moral recibida por la víctima, mientras que hermanos reciben un porcentaje de 2do grado."
    },
    {
      question: "¿Se incluye el lucro cesante por el tiempo en prisión?",
      answer: "Sí, el lucro cesante se calcula sumando el salario mensual real (o 1 SMLMV por defecto) indexado con prestaciones sociales durante todo el período de privación efectiva de la libertad."
    }
  ],
  "mora-contratos-estatales": [
    {
      question: "¿Cómo se liquidan los intereses de mora en un contrato estatal?",
      answer: "Conforme a la Ley 80 de 1993 Art. 4 Num. 8 y el Decreto 679 de 1994, se actualiza el capital mediante el IPC DANE y se aplica un interés moratorio del 1% mensual (12% anual)."
    },
    {
      question: "¿Sigue vigente el Decreto 679 de 1994?",
      answer: "Sí, rige para la contratación estatal de entidades públicas colombianas estableciendo el cálculo de actualización e intereses moratorios."
    }
  ],
  "competencia": [
    {
      question: "¿Qué determina la cuantía en un proceso?",
      answer: "Se determina sumando el valor acumulado de las pretensiones al momento de presentar la demanda y comparándolo con los límites de SMLMV del CGP Art. 25."
    },
    {
      question: "¿Qué juez es competente según la cuantía?",
      answer: "Mínima cuantía (≤40 SMLMV): Juez Municipal en única instancia; Menor cuantía (>40 y ≤150 SMLMV): Juez Municipal en primera instancia; Mayor cuantía (>150 SMLMV): Juez del Circuito."
    }
  ],
  "plazos": [
    {
      question: "¿Cómo se computan los plazos en días hábiles?",
      answer: "Los términos en días prescritos en el CGP y CPACA corren únicamente en días hábiles de la rama judicial, descartando sábados, domingos, festivos oficiales de Colombia y vacancia judicial."
    },
    {
      question: "¿Cuándo surte efectos la notificación por estado o correo electrónico?",
      answer: "Conforme a la Ley 2213 de 2022 y Art. 295 CGP, la notificación por estado se surte al finalizar el día de fijación y el término empieza a correr al día hábil siguiente."
    }
  ],
  "indexacion": [
    {
      question: "¿Qué es la indexación de valores?",
      answer: "Es la actualización de una suma de dinero histórica al valor presente mediante el Índice de Precios al Consumidor (IPC DANE) para corregir la depreciación monetaria por inflación."
    },
    {
      question: "¿Cuál es la fórmula judicial de indexación?",
      answer: "Vp = Vh * (IPC_final / IPC_inicial), donde Vh es el valor histórico y Vp el valor presente indexado."
    }
  ],
  "liquidacion-laboral": [
    {
      question: "¿Qué incluye la liquidación laboral?",
      answer: "Comprende Cesantías, Intereses sobre Cesantías (12%), Prima de Servicios, Vacaciones compensadas, Indemnización por despido injustificado (Art. 64 CST) y Sanción moratoria (Art. 65 CST)."
    },
    {
      question: "¿Cómo se liquida la indemnización por despido sin justa causa?",
      answer: "En contratos a término indefinido: 30 días de salario por el primer año y 20 días por cada año subsiguiente para salarios < 10 SMLMV."
    }
  ],
  "pension-ley797": [
    {
      question: "¿Cuáles son los requisitos de pensión de vejez en el RPM?",
      answer: "Cumplir la edad (62 años hombres / 57 años mujeres) y acreditar mínimo 1.300 semanas cotizadas en Colpensiones."
    },
    {
      question: "¿Cómo se determina la tasa de reemplazo?",
      answer: "Se aplica la fórmula r = 65.5 - 0.5*(IBL/SMLMV) + 1.5% por cada 50 semanas adicionales a las 1.300 mínimo, con tope del 80%."
    }
  ],
  "pension-invalidez": [
    {
      question: "¿Qué requisitos exige la pensión de invalidez de origen común?",
      answer: "El Art. 39 de la Ley 100 de 1993 (modificado por la Ley 860 de 2003) exige una pérdida de capacidad laboral (PCL) igual o superior al 50% y haber cotizado 50 semanas dentro de los 3 años anteriores a la fecha de estructuración. Para menores de 20 años basta acreditar 26 semanas en el último año."
    },
    {
      question: "¿Se exige fidelidad al sistema?",
      answer: "No. El requisito de fidelidad fue declarado inexequible por la Corte Constitucional en la Sentencia C-428 de 2009. No puede negarse la pensión por ese motivo."
    },
    {
      question: "¿Cómo se calcula el monto de la mesada pensional de invalidez?",
      answer: "Origen común (Art. 40 Ley 100/1993): si la PCL está entre 50% y 66%, 45% del IBL más 1.5% por cada 50 semanas sobre 500; si la PCL es ≥ 66%, 54% más 2% por cada 50 semanas sobre 800 (tope 75%). Origen laboral (Art. 10 Ley 776/2002): 60% del IBL (PCL 50-66%) y 75% (PCL ≥ 66%), con un +15% por gran invalidez (ayuda de terceros)."
    },
    {
      question: "¿Qué pasa si tengo la PCL pero no las semanas?",
      answer: "Antes de descartar el derecho debe evaluarse el principio de condición más beneficiosa (Ley 100 original o Acuerdo 049). Si no se cumplen las semanas, se liquida la indemnización sustitutiva o devolución de saldos."
    },
    {
      question: "¿Quién paga la pensión de invalidez de origen laboral?",
      answer: "La Administradora de Riesgos Laborales (ARL). La invalidez de origen común la reconoce el fondo de pensiones (Colpensiones o AFP)."
    }
  ],
  "retroactivo-pensional": [
    {
      question: "¿Qué es el retroactivo pensional?",
      answer: "Es el conjunto de mesadas dejadas de percibir o reconocidas en menor valor que el afiliado o pensionado tiene derecho a reclamar, contadas desde la causación del derecho. Aplica para pensiones reconocidas tardíamente o reliquidadas."
    },
    {
      question: "¿Cómo se actualiza el valor del retroactivo pensional?",
      answer: "El retroactivo puede actualizarse mediante indexación con el IPC, mediante intereses de mora (Art. 141 Ley 100), o de forma mixta. La indexación IPC mantiene el poder adquisitivo de cada mesada y los intereses de mora compensan el retardo."
    },
    {
      question: "¿Desde cuándo se cuenta el retroactivo?",
      answer: "Desde la fecha de causación del derecho, es decir, desde cuando debió empezar a pagarse la mesada correcta. Se calcula la diferencia entre la mesada real que debió pagarse y la efectivamente reconocida durante el período reclamado."
    },
    {
      question: "¿El retroactivo incluye las mesadas adicionales de junio y diciembre?",
      answer: "Sí. El cálculo incluye automáticamente las mesadas adicionales de junio (mesada 13) y diciembre (mesada 14 si aplica), de modo que el total a reclamar refleje todas las mesadas dejadas de percibir."
    },
    {
      question: "¿Qué diferencia hay entre indexación IPC e intereses de mora?",
      answer: "La indexación IPC actualiza cada mesada para conservar su valor real frente a la inflación, mientras que los intereses de mora se aplican como sanción por el retardo en el pago, usando la tasa de usura de la Superfinanciera."
    }
  ],
  "dosificacion-punitiva": [
    {
      question: "¿Cómo funciona el sistema de cuartos punitivos (Art. 61 CP)?",
      answer: "Se resta la pena mínima de la máxima para hallar el ámbito de punibilidad y se divide en 4 partes iguales: Cuarto mínimo, cuartos medios y cuarto máximo según atenuantes o agravantes."
    },
    {
      question: "¿Qué rebaja aplica por allanamiento o preacuerdo?",
      answer: "Hasta 50% en formulación de imputación, hasta 33.3% en formulación de acusación y hasta 16.6% en audiencia de juicio oral."
    }
  ],
  "perjuicios-traslado-pensional": [
    {
      question: "¿Qué liquida esta calculadora de la Sala de Casación Laboral de la CSJ?",
      answer: "Liquida la indemnización por perjuicios derivados de la ineficacia del traslado pensional bajo la figura de pérdida de oportunidad (loss of chance). Aplica la fórmula oficial de la Corte Suprema: PP × (MesadaRPM − MesadaRAIS) × (EVaños × 13)."
    },
    {
      question: "¿Cómo se calcula la condición o Probabilidad Pensional (PP)?",
      answer: "PP = 0.5 × (S/1300)^0.5 × 2^(-|EP - ER|/100). Considera la base del 50% por coexistencia de regímenes, la densidad de semanas cotizadas al momento del traslado y la cercanía de la edad del afiliado respecto de la edad exigida por la ley."
    },
    {
      question: "¿Qué tabla de expectativa de vida (EV) se utiliza?",
      answer: "Se fundamenta en la Tabla de Rentistas fijada por la Superintendencia Financiera de Colombia (Resolución 1555 de 2010), deduciendo el sexo según la edad exigida por la ley (62 años Hombre, 57 años Mujer) o la edad a la causación."
    }
  ]
};
